"use client";
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import { register } from 'swiper/element/bundle';

const ProductImages = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(false);
  const mainSwiperRef = useRef(null);
  const thumbSwiperRef = useRef(null);
  const filtered_images = images?.filter(image => image?.url);

  if (!filtered_images || filtered_images?.length === 0) {
    return null;
  }

  useEffect(() => {
    register();

    const paramsMain = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: thumbSwiperRef.current,
      },
      on: {
        slideChange(s) {
          setActiveIndex(s.activeIndex);
        },
        init(s) {
          setActiveIndex(s.activeIndex);
        },
      },
      slidesPerView: 1,
      spaceBetween: 16,
    };

    Object.assign(mainSwiperRef.current, paramsMain);
    mainSwiperRef.current.initialize();

    const paramsThumbs = {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: true,
      watchSlidesProgress: true,
    };

    Object.assign(thumbSwiperRef.current, paramsThumbs);
    thumbSwiperRef.current.initialize();
  }, [filtered_images]);

  return (
    <>
      <div className="relative bg-white rounded-10">
        <swiper-container init="false" ref={mainSwiperRef} className="">
          {filtered_images?.map((image, idx) => {
            const key = [image?.id, image?.variation_id, idx].join(" - ");
            
            return (
              <swiper-slide key={key} class="!w-full flex justify-center h-[91vw] md:h-[38rem]">
                <div className="flex items-center justify-center w-full h-full p-8 lg:p-16">
                  <Image
                    src={image?.url}
                    alt={image?.alt}
                    className="!relative object-contain"
                    fill
                  />
                </div>
              </swiper-slide>
            )
          })}
        </swiper-container>
        {filtered_images?.length > 1 && (
          <div className="absolute flex justify-between w-full pointer-events-none top-[calc((90vw/2)-1rem)] md:top-[calc((38rem/2)-1rem)] px-4 md:px-6 z-10">
            <button
              className={`flex justify-center items-center rounded-full transition-all duration-300 h-8 w-8 swiper-button-prev ${activeIndex == 0
                ? "bg-body"
                : "pointer-events-auto bg-dark-bg"
              }`}
            >
              <FontAwesomeIcon
                icon={faChevronLeft}
                className="w-auto h-3 text-white"
              />
            </button>
            <button
              className={`flex justify-center items-center pointer-events-auto rounded-full h-8 w-8 swiper-button-next 
              ${(activeIndex == images?.length - 1)
            ? "bg-body"
            : "pointer-events-auto bg-dark-bg"
          }`}
            >
              <FontAwesomeIcon
                icon={faChevronRight}
                className="w-auto h-3 text-white"
              />
            </button>
          </div>
        )}
      </div>

      <div className="hidden w-full md:block">
        <swiper-container init="false" ref={thumbSwiperRef}>
          {filtered_images?.map((image, index) => {
            const key = [image?.id, image?.variation_id, index].join(" - ");
            
            return (
              <swiper-slide
                key={key}
                class={`!w-20 !h-20 bg-white rounded-10 cursor-pointer ${activeIndex == index
                  ? "border-2 border-body-dark"
                  : "border-2 border-transparent"
                }`}
              >
                <div
                  className={`flex items-center justify-center w-full h-full p-[0.875rem] `}
                >
                  <Image
                    src={image?.url}
                    alt={image?.alt}
                    className="object-contain !relative"
                    fill
                  />
                </div>
              </swiper-slide>

            )
          })}
        </swiper-container>
      </div>
    </>
  )
};

export default ProductImages;